<button
  type="button"
  class="h-10 aspect-[3/2] min-h-0 min-w-0 shrink-0 overflow-hidden rounded-lg border-0 bg-white p-0"
>
  @if (languageFlagUrl) {
    <img
      class="h-full w-full object-cover object-center"
      [src]="languageFlagUrl"
      alt=""
    />
  }
</button>
